import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ERROR_MESSAGES } from './error.messages.const';
import { TextService } from './text.service';
import { ErrorModel } from './error.model';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private text = inject(TextService);
  private notification = inject(NotificationService);

  handleKnownError(error: keyof typeof ERROR_MESSAGES): Observable<never> {
    const message = ERROR_MESSAGES[error] ? ERROR_MESSAGES[error] : this.text.get('request_failed');
    this.showNotification(message);
    return throwError(() => message);
  }

  handle(response: HttpErrorResponse, message?: string): Observable<never> {
    const error: ErrorModel = response.error;
    const responseMessage = Array.isArray(error?.message) ? error.message.join() : error.message;
    this.showNotification(responseMessage);
    return throwError(() => responseMessage);
  }

  private showNotification(message: string): void {
    this.notification.error(message);
  }
}
